import { useEffect, useMemo, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { GetSubscriptionList, GetUserDetail, UpdateSubscription } from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";
const usePricing = () => {
  const { getState, dispatch } = useReduxStore();
  const {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    subscriptionList
  } = getState("Home");
  const {token,subscription,cancelSubscription,userData}=getState("AUTH")
  const [modalType, setModalType] = useState(null);
  const [selectedSubscription, setSelectedSubscription] = useState(null);
 const [errorMessage, setErrorMessage] = useState("");
 const isVerify=userData?.isVerified



 // Use dummy data if API doesn't return data
 const finalSubscriptionList =  subscriptionList;
 const planeId=useMemo(()=>{
  // subscription?.length?subscription[0].planId._id:""
  let obj=subscription.find(s=>s.planId?.price>0)
  return obj?._id?obj?.planId?._id:""
 },[subscription])
// console.log("user Data --------",userData)
const activePlan=useMemo(()=>{
let obj=subscription.find((p)=>p?.planId?.price>0)
if(obj?._id){
return {
      name:obj?.planId?.name,
    price:obj?.planId?.price,
    duration: 'Monthly',
    ...obj
}
}
else{
return {}
}
},[subscription])  
let isCancelled=activePlan?.status==="canceled"?true:false
 const my_subscription={...activePlan}
    const handelModalType = (type,message) =>{
     setModalType(type)
     setErrorMessage(message)
     }
     const onConfirmUpgrade=()=>{
      
       dispatch(UpdateSubscription({newPlanId:selectedSubscription?._id}))
     }
  useEffect(() => {
    dispatch(GetSubscriptionList());
    // dispatch(GetHomeData());
  }, []);
  useEffect(() => {
   cancelSubscription&& dispatch(GetUserDetail({ stopLoading:true }));
  }, [cancelSubscription]);
// console.log("data-----",subscriptionList?.length)
  return {
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    subscriptionList,
    token,
    planeId,
    modalType,
    errorMessage,
    my_subscription,
    selectedSubscription,
    isCancelled,
    isVerify,
    onConfirmUpgrade,
    setSelectedSubscription,
    handelModalType,
  };
};

export default usePricing;
